import { helper } from '@ember/component/helper';

import { getOrElse } from '../utils/object-utils';

export function orElse([value, elseValue]: [any, any]) {
  return getOrElse(value, elseValue);
}

const orElseHelper = helper(orElse);
export default orElseHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'or-else': typeof orElseHelper;
  }
}
